import axios from "./httpClient";
import { ApiType } from "./Types";
import { getTrackingHeadersMap } from "./getTrackingHeaders";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOvEntry } from "../models/overage";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Create overage entry and return same object
 */

export const CreateOverageEntryAPI = async (params: IOvEntry) => {
  try {
    // Get static headers from map
    const staticHeaders = getTrackingHeadersMap(ApiType.OVERAGE_CREATE);
    // Add dynamic OSD-Exception-Type
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Type": params.type, // Assuming 'type' field in params indicates the overage type
    };
    const response = await axios.post(getUrl(ApiType.OVERAGE_CREATE), params, { headers });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.createOverageEntry, { badRequestOrder: "errorsFirst" });
  }
};
